import { render, staticRenderFns } from "./CampoFechaEnvioSii.vue?vue&type=template&id=21a6ccb8&scoped=true&"
import script from "./CampoFechaEnvioSii.vue?vue&type=script&lang=js&"
export * from "./CampoFechaEnvioSii.vue?vue&type=script&lang=js&"
import style0 from "./CampoFechaEnvioSii.vue?vue&type=style&index=0&id=21a6ccb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6ccb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a6ccb8')) {
      api.createRecord('21a6ccb8', component.options)
    } else {
      api.reload('21a6ccb8', component.options)
    }
    module.hot.accept("./CampoFechaEnvioSii.vue?vue&type=template&id=21a6ccb8&scoped=true&", function () {
      api.rerender('21a6ccb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/campos/CampoFechaEnvioSii.vue"
export default component.exports